var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.8 43.4l3.2-15c1-4.4-1.8-9-6.4-9.8l-1.2-0.2c-4.4-1-9 1.8-9.8 6.4l-3.2 15 17.4 3.6z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.6 45.8l-1.2 5.8c-0.6 3.2 1.4 6.4 4.6 7l2.8 0.6c3.2 0.6 6.4-1.4 7-4.6l1.2-5.8-14.4-3z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21.8 29.8v-15.4c0-4.6-3.6-8.4-8.2-8.4h-1.2c-4.6 0-8.4 3.8-8.4 8.4v15.4h17.8z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.6 35.8v6c0 3.2 2.6 6 6 6h3c3.2 0 6-2.6 6-6v-6h-15z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/logs.8c9d2121d30fabaf81551c3d2cec3e94.svg";
export { ForwardRef as ReactComponent };